import { RouterProvider } from './routes/Router';
import 'react-toastify/dist/ReactToastify.css';
import ReactGA from 'react-ga4';

// Inicialize com o seu ID do Analytics
ReactGA.initialize(import.meta.env.VITE_GOOGLE_ANALYTICS_ID, {
	gtagOptions: { send_page_view: false },
});

// Se quiser vincular o Google Ads também por aqui:
ReactGA.gtag('config', import.meta.env.VITE_GOOGLE_ADS_ID, {
	send_page_view: false,
});

function App() {
	return <RouterProvider />;
}

export default App;
